module.exports = __webpack_public_path__ + "img/email.a0a7b4a4.svg";